import { Typography } from "@mui/material";
import NumberFormats from "components/NumberFormats";
import { VALUE_BALANCE } from "pages/Wallet/constants";
import React from "react";

export default function TextEquity({ item, color, valueBalance, ...props }) {
  return (
    <Typography component="p">
      <Typography
        variant="h5"
        component="span"
        color={color || "text.main"}
        {...props}
      >
        <NumberFormats value={item?.equityValue} /> /{" "}
      </Typography>
      <Typography component="span" color={"text.secondary"} variant="h5">
        <NumberFormats
          value={
            valueBalance === VALUE_BALANCE.USDT
              ? item?.equityValueUSDT
              : item?.equityValueToman
          }
        />{" "}
        {valueBalance === VALUE_BALANCE.USDT ? "USDT" : "Toman"}
      </Typography>
    </Typography>
  );
}
